import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { type CartParams } from 'src/app/pages/cart';
import { useAppSelector } from 'src/utils';
import { post } from 'src/utils/helpers/http';
import { useBaseAPIParams } from 'src/utils/hooks/useBaseAPIParams';

import { type Cart } from './types';

// oxlint-disable-next-line no-named-export
export const GetCart = 'get-cart';

const GET_CART_URL = '/v2/cart/get-curbside-cart';

type UseGetCartQueryType = {
  enabled?: boolean;
  FeePaymentMethodIds?: number[];
  registerId?: number;
};

// oxlint-disable-next-line no-named-export
export function useCart(props?: UseGetCartQueryType) {
  const baseAPIParams = useBaseAPIParams();
  const { shipmentId, customerId } = useParams<CartParams>();
  const selectedRegister = useAppSelector((state) => state.user.selectedRegister);

  return useQuery({
    queryKey: [GetCart, shipmentId],
    queryFn: async () => {
      const res = await post<Cart>(GET_CART_URL, {
        ...baseAPIParams,

        AcctId: Number(customerId),
        ShipmentId: Number(shipmentId),
        Register: props?.registerId ?? selectedRegister?.id ?? 0,

        Timestamp: 0,
        FeePaymentMethodIds: props?.FeePaymentMethodIds,
      });
      return res;
    },
    enabled: props?.enabled ?? !!(customerId && shipmentId),
    staleTime: 0,
    gcTime: 0,
  });
}
